
<template>
	<c-dialog ref="dialog" mode="slide" width="100vw-300" mask-close @close="dialogFormEditConfirm($refs.orderForm, arguments)" @resolve="submitHandle">
		<c-form ref="orderForm" column="3" vertical unit-width="100%">
			<c-form link-parent>
				<c-form-item label="采购单号">
					<c-input name="purchase_code" placeholder="请输入，不填将自动生成" :disabled="this.purchase_order_id > 0"></c-input>
				</c-form-item>
                <c-form-item label="供应商">
                    <c-select ref="supplierSelector" name="supplier_id" async @search="searchSupplier" :value-data="supplierOptions" @change="setLinkedData"></c-select>
                    <template #handle>
                        <c-link icon v-if="auth('b_supplier_edit')" @click="globalDialog('supplierEdit',{})">创建供应商</c-link>
                    </template>
                </c-form-item>
                <c-form-item label="采购日期" required>
                    <c-datetime name="purchase_date" type="date" placeholder="请选择采购日期"></c-datetime>
                </c-form-item>
                <c-form-item label="预计交期" required>
                    <c-datetime name="plan_delivery_date" type="date" placeholder="请选择计划交货日期"></c-datetime>
                </c-form-item>
                <c-form-item label="采购员">
                    <c-select ref="purchaseUserSelector" name="purchase_user_id" async @search="searchUser" :value-data="sysuserOptions" @change="setLinkedData"></c-select>
                </c-form-item>

				<!--自定义字段数据-->
				<custom-form ref="customForm" work-type="39"></custom-form>
			</c-form>

			<c-title>产品明细</c-title>
			<c-form-item :label="false" name="product_list" colspan="3">
				<custom-table ref="productTable" view-id="10015" work-type="40">
					<template #operate>
						<c-button color="main" prepend-icon="tf-add" @click="globalDialog('productSelector', {props: {initParam: {product_sources:[2]}}}, productSelectorHandle)">添加产品</c-button>
						<c-button prepend-icon="tf-add" @click="selectOrderProduct">按订单添加</c-button>
					</template>
					
					<!--关联订单号-->
					<template #order_code="{data}">
						<span v-if="data.order_code">{{data.order_code}}</span>
						<span v-else>-</span>
					</template>
					
					<!--采购数量-->
					<template #purchase_count="{data}">
						<c-input type="number" decimal="6" :range="[0.000001,99999999]" name="purchase_count" v-model="data.purchase_count" :clear="false" required></c-input>
					</template>

					<!--采购单价-->
					<template #purchase_price="{data}">
						<c-input type="number" decimal="6" :range="[0,99999999]" v-model="data.purchase_price" :clear="false"></c-input>
					</template>

					<c-table-column
                        type="button"
                        label="操作"
						width="60"
                    >
                        <template #default="{data,remove}">
							<c-table-button v-if="auth('b_purchase_order_create') || auth('b_purchase_order_edit')" icon="tf-trash" @click="removeProductRow(data,remove)">删除</c-table-button>
						</template>
					</c-table-column>
				</custom-table>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
	export default {
		name: 'purchaseOrderEdit',
		
		data() {
			return {
				purchase_order_id:0,
				editState: false,
                supplierOptions: [],//已选中的供应商信息
                sysuserOptions: [],//已选中的采购员
				deleteProductList: []
			}
		},

		methods: {
			open(data) {
                //初始化自定义字段控件
				this.$refs.customForm.init();
				//初始化产品列表控件
				this.$refs.productTable.init();
				
				this.editState = !!data.id;
				
				this.deleteProductList = [];
				//清空表单数据
				this.$refs.orderForm.clear();
				
				if (data.id) {
					this.purchase_order_id = data.id;
					this.getDetail();
				} else {
					this.purchase_order_id = 0;
                    //采购日期设置为 今日
                    this.$refs.orderForm.set({
                        purchase_date: new Date().format('yyyy-MM-dd')
                    });
				}
				if (data.orderProductList) {
					this.selectOrderProductHandle(data.orderProductList);
				}
				this.$refs.dialog.open({
					title: data.id ? '编辑采购单' : '创建采购单'
				});
			},
			
			/*******搜索订单详情*******************/
			getDetail() {
				this.request({
					url:'/purchase/order/detail',
					data: {
						id: this.purchase_order_id
					},
					loading: true,
					success: data => {
						//订单基本信息
						this.$refs.orderForm.set(data.detailInfo);
						//存在供应商
						if(data.detailInfo.supplier_id){
							//处理选中客户信息
							this.supplierOptions = [{
								name: data.detailInfo.supplier_code +' | ' +data.detailInfo.supplier_name,
								value: data.detailInfo.supplier_id
							}];
						}
						//存在采购员
						if(data.detailInfo.purchase_user_id){
							//处理选采购员
							this.sysuserOptions = [{
                                name: data.detailInfo.purchase_user_realname,
                                value: data.detailInfo.purchase_user_id
							}];
						}
						//加载工单列表
						this.$refs.productTable.$refs.list.setData(data.productList);
					}
				});
			},

            /*******搜索【供应商】下拉框信息*****************/
            searchSupplier(keyword, resolve){
                this.request({
                    url:'/system/options',
                    data: {
                        options_code:'SUPPLIER',
                        keyword: keyword
                    },
                    success:data => {
                        resolve(data);
                    }
                })
            },

            /************搜索用户*******************************/
            searchUser(keyword, resolve){
                this.request({
                    url:'/system/options',
                    data: {
                        options_code:'SYSUSER',
                        keyword:keyword
                    },
                    success:data => {
                        resolve(data);
                    }
                })
            },

			setLinkedData() {
				this.$refs.customForm.setDefaultData({
					work_type_id: 39,
					source_list: [[{
						ref_work_type_id: 12,
						ref_id: this.$refs.supplierSelector.get()
					}, {
						ref_work_type_id: 27,
						ref_id: this.$refs.purchaseUserSelector.get()
					}]]
				});
			},
			
			/******选择产品响应方法*********/
			async productSelectorHandle(data) {
                // //判断是否已存在于表格之中，已存在则不允许添加
                // for (var i = 0; i < data.length; i++) {
                //     var newProduct = data[i];
                //     var existObj = this.$refs.productTable.$refs.list.getData().find(function (obj) {
                //         return obj.product_id == newProduct.id
                //     });
                //     if (existObj){
                //         this.$message({
                //             type:'warn',
                //             message:'产品【'+existObj.product_code+' | '+existObj.product_name+'】已存在，请勿重复添加',
                //         });
                //         return;
                //     }
                // }

				//处理数据
				this.$refs.productTable.$refs.list.push(
					await this.$refs.productTable.setDefaultData(data.map(item => {
						return Object.assign({}, item, {
							id: null,
							product_id: item.id,
							purchase_price: item.product_price
						});
					}), {
						work_type_id: 40,
						source_list: data.map(item => {
							return [{
								ref_work_type_id: 7,
								ref_id: item.product_id
							}]
						})
					})
				);

				//当已选择供应商时，按【供应商+产品】批量抓取最近采购单价覆盖默认值
				this.fetchLastPurchasePrice();
			},

			/*******批量抓取供应商下产品的最近采购单价************
			 * 后端接口待开发：/purchase/order/lastPrice
			 * 请求参数：{ supplier_id, product_ids: [id1,id2,...] }
			 * 返回数据：[ { product_id, purchase_price } ]
			 * 已选供应商时调用，无供应商时跳过，保持原 product_price 默认值
			 ***********************************************/
			fetchLastPurchasePrice() {
				const supplierId = this.$refs.supplierSelector.get();
				if (!supplierId) return;

				const rowList = this.$refs.productTable.$refs.list.getRow();
				if (!rowList.length) return;

				const productIds = rowList.map(row => row.data.product_id).filter(Boolean);
				if (!productIds.length) return;

				this.request({
					url: '/purchase_product/lastPurchasePrice',
					data: {
                        purchase_order_id: this.purchase_order_id,
						supplier_id: supplierId,
						product_ids: productIds
					},
					success: res => {
						if (!res || !res.length) return;
						const priceMap = {};
						res.forEach(item => {
							priceMap[item.product_id] = item.purchase_price;
						});
						rowList.forEach(row => {
							const newPrice = priceMap[row.data.product_id];
							if (newPrice != null) {
								row.update({ purchase_price: newPrice });
							}
						});
					}
				});
			},
			
			//按订单添加-弹框
			selectOrderProduct() {
				this.globalDialog('orderProductSelector', this.selectOrderProductHandle);
			},
			
			//按订单添加相应方法
			async selectOrderProductHandle(data) {
				this.$refs.productTable.$refs.list.push(
					await this.$refs.productTable.setDefaultData(data.map(item => {
						return Object.assign({}, item, {
							id: null,
							purchase_count: item.main_product_count,
							create_date: null,
							create_user_realname: null
						});
					}), {
						work_type_id: 40,
						source_list: data.map(item => {
							return [{
								ref_work_type_id: 1,
								ref_id: item.order_id
							}, {
								ref_work_type_id: 41,
								ref_id: item.id
							}, {
								ref_work_type_id: 7,
								ref_id: item.product_id
							}]
						})
					})
				);
                this.fetchLastPurchasePrice();
			},
			
			/******删除产品行数据********/
			removeProductRow(data, remove) {
				if (data.id && data.id > 0){
					this.deleteProductList.push(data.id);
				}
				remove();
			},

			/*******提交编辑数据********************/
			submitHandle(stop, next) {
				stop();
				
				//产品工单列表
				var product_list = this.$refs.productTable.$refs.list.getData();
				
				this.$refs.orderForm.submit({
					url: this.purchase_order_id==0?'/purchase/order/add':'/purchase/order/edit',
					rule: {
                        // supplier_id: '请选择供应商',
                        purchase_date: '请选择采购日期',
                        plan_delivery_date: '请选择预计交期',
						product_list: data => {
							var flag = true;
							if(product_list.length == 0){
								let msg = "请至少有一个产品信息";
								return msg;
							} 
							product_list.forEach(item => {
								if(!item.purchase_count || parseFloat(item.purchase_count)<=0){
									flag = false;
								}
							});

							if (!flag) {
								let msg = "请完善产品明细";
								return msg;
							}
							//自定义字段校验
							return this.$refs.productTable.validate();
						},
						...this.$refs.customForm.rule
					},
					dataFormatter: data => {
						data.id = this.purchase_order_id||0;
						data.purchase_user_id = data.purchase_user_id||0;
						data.supplier_id = data.supplier_id||null;
						//产品列表
						data.product_list = product_list.map(item => {
							return {
								id: item.id,
								order_id: item.order_id,
								order_product_id: item.order_product_id,
								product_id: item.product_id,
                                purchase_count: item.purchase_count,
                                purchase_price: item.purchase_price||0,
                                custom_fields_value_json:JSON.stringify(item.custom_fields_value_json)
                            }
						});
						//被删除的任务ID列表
						data.delete_product_list = this.deleteProductList.map(item => {
							return {id:item}
						});
						//表单自定义字段
						data.custom_fields_value_json = JSON.stringify(data.custom_fields_value_json);
						return data;
					},
					success: () => {
						next();
						this.$message({
							type: 'success',
							message:this.editState ? '编辑采购单成功' : '创建采购单成功',
						});
						//刷新页面
						this.$emit('resolve');
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>